/**
 * Phaser ゲームインスタンスの生成。
 *
 * 論理解像度を固定（480x720）し Scale.FIT で拡縮するため、
 * 半径や重力の調整値がどの端末でも同じ意味になる。
 */

import Phaser from 'phaser';

import { GAME_TUNING } from './config/gameConfig';
import type { GameContext } from './GameContext';
import { BootScene } from './scenes/BootScene';
import { BackgroundScene } from './scenes/BackgroundScene';
import { GameScene } from './scenes/GameScene';

export function createGame(context: GameContext, parent: HTMLElement): Phaser.Game {
  const { width, height } = GAME_TUNING.world;
  const physics = GAME_TUNING.physics;

  const game = new Phaser.Game({
    type: Phaser.AUTO,
    parent,
    backgroundColor: context.stage.theme.backgroundColor,
    // シーン生成前にコンテキストを登録する
    callbacks: {
      preBoot: (instance) => instance.registry.set('context', context),
    },
    scale: {
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width,
      height,
    },
    // キーボードは DOM 側で一元管理する（二重処理を避けるため）
    input: {
      keyboard: false,
      mouse: true,
      touch: true,
    },
    // 音声は AudioSystem 側で扱うため Phaser 側は無効化する
    audio: { noAudio: true },
    banner: false,
    physics: {
      default: 'matter',
      matter: {
        gravity: { x: 0, y: physics.gravityY },
        enableSleeping: physics.enableSleeping,
        positionIterations: physics.positionIterations,
        velocityIterations: physics.velocityIterations,
        constraintIterations: physics.constraintIterations,
        debug: false,
      },
    },
    scene: [BootScene, BackgroundScene, GameScene],
  });

  return game;
}
